import { API_URL } from "env";

async function updateSubcriptions(subId: number, name: string, desc: string, price: number) {
    const token = localStorage.getItem("token");
    try {
        if (!token) throw new Error("No token found");
        const response = await fetch(`${API_URL}api/v1/be/subscriptions/${subId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                name,
                description: desc,
                price,
            }),
        });
        const data = await response.json();
        if (!data) {
            throw new Error(data.message || "Failed to update subscription");
        }
        return data || null;
    }
    catch (error) {
        console.error("Error updating subscription:", error);
        return null;
    }
}
export default updateSubcriptions;